import { useTranslation } from "react-i18next";
import ModalDialog from "./Modal";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ActionButton from "./ActionButton";

interface IProps {
  error: any;
  resetErrorBoundary: (...args: any[]) => void;
}

const ErrorFallback = ({ error, resetErrorBoundary }: IProps) => {
  const { t } = useTranslation();
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  return (
    <div>
      <ModalDialog
        state={true}
        title={t("APIErrorMessages.unexpectedError")}
        onClose={""}
        size="s"
        closeButtonHide={true}
        content={
          <div>
            <div className="flex session-timeout-body">
              <div className="flex center margin-right-5">
                <ReportProblemIcon style={{ color: "red" }} />
              </div>
              <div className="font-14 margin-y-10 flex center red">
                {error.message}
              </div>
            </div>
            <div className="border-top padding-up-15 padding-down-10 center-end flex-gap bottom-btn center-end">
              <ActionButton
                onClick={resetErrorBoundary}
                label={t("Please Try Again")}
              ></ActionButton>
            </div>
          </div>
        }
      ></ModalDialog>
    </div>
  );
};

export default ErrorFallback;
